<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">{{modalHeading}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onOkClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div v-if="!loading">
                    <!-- Search Input -->
                    <div class="row mb-3">
                        <div class="col-12">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <i class="fa fa-search"></i>
                                    </span>
                                </div>
                                <input 
                                    type="text" 
                                    class="form-control" 
                                    placeholder="Search audit records..." 
                                    v-model="searchQuery" 
                                    @input="onSearchInput">
                            </div>
                        </div>
                    </div>

                    <!-- Audit Records Table -->
                    <div class="table-responsive">
                        <table class="table table-striped table-bordered">
                            <thead class="thead-light">
                                <tr>
                                    <th style="width: 20%;">Date</th>
                                    <th style="width: 20%;">Updated By</th>
                                    <th style="width: 60%;">Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="audit in filteredAuditRecords" :key="audit.auditId">
                                    <td>{{ audit.formattedDate }}</td>
                                    <td>{{ audit.changeMadeByUserName || 'N/A' }}</td>
                                    <td>{{ audit.description || 'N/A' }}</td>
                                </tr>
                                <tr v-if="filteredAuditRecords.length === 0">
                                    <td colspan="3" class="text-center text-muted">
                                        <em>{{ searchQuery ? 'No audit records match your search criteria.' : 'No audit records found for this order.' }}</em>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" data-dismiss="modal" @click="onOkClick" :disabled="loading">OK</button>
            </div>
        </div>
    </div>
</div>